import React, { useState } from "react";
import { deleteTask } from "../../services/service";
import DeletConfirmation from "../../atoms/deletConfirmation";
import { formatWorkedDuration } from "./WorkersBar";

const TaskWorkerHoursBadge = ({ username, seconds }) => (
  <span
    title={`${username} spent this much time on this task`}
    className="flex items-center gap-1 bg-[#DEE2ED] text-[#1E3A8A] text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap"
  >
    <svg
      width="10"
      height="10"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15.5 14" />
    </svg>
    {username}: {formatWorkedDuration(seconds)}
  </span>
);

const TasksBar = ({
  handleOpenSidebar,
  tasks,
  setDeleteSuccess,
  deleteSuccess,
}) => {
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);

  const handleDeleteClick = (id) => {
    setSelectedTaskId(id);
    setIsDeleteModalVisible(true);
  };

  const closeModal = () => {
    setIsDeleteModalVisible(false);
    setSelectedTaskId(null);
  };

  const handleDelete = async () => {
    if (!selectedTaskId) return;
    setIsLoading(true);
    await deleteTask(selectedTaskId);
    setIsLoading(false);
    closeModal();
    setDeleteSuccess(!deleteSuccess);
  };

  return (
    <div>
      <div className="w-full flex items-center justify-between pt-3 px-3">
        <p className="text-base font-semibold text-[#1E3A8A] mb-3">Tasks</p>
        <button
          onClick={handleOpenSidebar}
          className="w-[77px] h-[24px] rounded-[4px] pb-[1px] bg-[#F97316] text-[13px] text-white font-medium hover:bg-orange-600 transition-colors"
        >
          Add Task
        </button>
      </div>
      {tasks?.length > 0 ? (
        tasks.map((task, index) => (
          <div
            key={task?.id || index}
            className="w-full flex items-center justify-between px-3 py-2 border-b border-b-[#EFEFEF] hover:bg-gray-50 rounded-lg"
          >
            <div className="flex flex-col gap-1 flex-1 min-w-0">
              <span className="font-normal text-[14px] text-[#4B5563]">
                {task?.title}
              </span>
              {task?.workerHours?.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {task.workerHours.map((wh) => (
                    <TaskWorkerHoursBadge
                      key={wh.worker_id}
                      username={wh.username || `Worker #${wh.worker_id}`}
                      seconds={wh.total_seconds}
                    />
                  ))}
                </div>
              )}
            </div>
            <button
              onClick={() => handleDeleteClick(task?.id)}
              className="font-medium text-[14px] text-[#E90C0C] shrink-0 ml-2"
            >
              Remove
            </button>
          </div>
        ))
      ) : (
        <div className="w-full px-3 py-4 text-center text-gray-500">
          No tasks available
        </div>
      )}
      {isDeleteModalVisible && (
        <DeletConfirmation
          onClose={closeModal}
          deleteModal={isDeleteModalVisible}
          setDeleteModal={setIsDeleteModalVisible}
          handleDelete={handleDelete}
          isLoading={isLoading}
          task={true}
        />
      )}
    </div>
  );
};

export default TasksBar;
